import { render } from "./form.vue?vue&type=template&id=e21c2d7e"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
script.render = render

export default script